import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import httpClient from '../../../http/HttpRequest';
import { GET_CUSTOMER, GET_STATES,UPDATE_BILLING_DETAILS } from '../../../data/url';
import Alert from '../../../feature/Alert';
import FormLayout from '../layout/FormLayout';
import ContentHeader from '../layout/ContentHeader'
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { GST_TYPES } from '../../../data/constant';

export default function TaxDetails() {

     const { id } = useParams();
     const { customerType } = useParams();
     const navigate = useNavigate();
     const { t } = useTranslation();
     const [directSubmit, setDirectSubmit] = useState(1);
     const [customerData, setCustomerData] = useState({});
     const [states, setStates] = useState({});
     const action = 'UPDATE';
     const [formData, setFormData] = useState({
          formTitle: 'Add Product',
          formFields: [
               { label: 'business_name', id: 'bussiness_name', type: 'text', name: 'bussiness_name', value: '', required: true, className: "col-md-4" },
               { label: 'gst_number', id: 'gst_number', type: 'text', name: 'gst_number', value: '', required: true, className: "col-md-4" },
               { label: 'gst_type', id: 'gst_type', type: 'select', name: 'gst_type', value: '', required: true, options: [], className: "col-md-4" },
               { label: 'pan_number', id: 'pan_number', type: 'text', name: 'pan_number', required: true, value: '', className: "col-md-4" },
               { label: 'vat', id: 'vat', type: 'text', name: 'vat', value: '', className: "col-md-4" },
               { label: 'address', id: 'address', type: 'textarea', name: 'address', required: true, value: '', className: "col-md-4" },
               { label: 'city', id: 'city', type: 'text', name: 'city', value: '', required: true, className: "col-md-4" },
               { label: 'pincode', id: 'pincode', type: 'number', name: 'pincode', required: true, value: '', className: "col-md-4" },
               { label: 'state', id: 'state', type: 'select', name: 'state', value: '', options: [], className: "col-md-4", required: true, }
          ],
          formErrors: { bussiness_name: '', gst_number: '', gst_type: '', pan_number: '', vat: '', address: '', city: '', pincode: '', state: '' },
     });

     useEffect(() => {
          getState();
          getGstType();
          getCustomerData();
     }, [id]);

     const getState = async (e) => {
          const res = await httpClient.post(GET_STATES, {});
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setStates(result.data);
                    let options = [];
                    result.data.forEach((row, index) => {
                         options.push({ label: row.name, value: row.id });
                    });
                    updateFormFieldOptions(options, 'state');
               }
          }
     }

     const getGstType = () => {
          let options = [];
          Object.keys(GST_TYPES).forEach(key => {
               const value = GST_TYPES[key];
               options.push({ label: value, value: key });
          });
          updateFormFieldOptions(options, 'gst_type');
     }


     const updateFormFieldOptions = (newOptions, fieldName) => {
          setFormData(prevFormData => {
               const updatedFormFields = prevFormData.formFields.map(field => {
                    if (field.name === fieldName) {
                         return {
                              ...field,
                              options: newOptions,
                         };
                    }
                    return field;
               });
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     };

     const getCustomerData = async () => {
          if (id) {
               const res = await httpClient.post(GET_CUSTOMER, { customer_id: id });
               if (res.requestStatus === 'OK') {
                    const result = res.result;
                    if (result.status === 1) {
                         setCustomerData(result.data);
                         setFormData(prevFormData => {
                              const updatedFormFields = prevFormData.formFields.map(field => {
                                   if (field.name in result.data) {
                                        field.value = result.data[field.name];
                                   }
                                   return field;
                              });
                              return {
                                   ...prevFormData,
                                   formFields: updatedFormFields,
                              };
                         });
                    } else {
                         Alert.error(res.message);
                         navigate('/root/customer');
                    }
               }
          }
     };

     function handleFieldChange(fieldName, value) {
          setDirectSubmit(0);
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     function handleFieldBlur(fieldName, value) {
          setDirectSubmit(0);
          validateField(fieldName, value);
     }

     function validateField(fieldName, value) {
          setFormData((prevFormData) => {
               const updatedErrors = { ...prevFormData.formErrors };
               if (fieldName === 'bussiness_name') {
                    updatedErrors.bussiness_name = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'gst_number'){
                    updatedErrors.gst_number = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'gst_type'){
                    updatedErrors.gst_type = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'pan_number'){
                    updatedErrors.pan_number = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'address'){
                    updatedErrors.address = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'city'){
                    updatedErrors.city = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'pincode'){
                    updatedErrors.pincode = value.trim() === '' ? 'field_required' : '';
               }else if(fieldName === 'state'){
                    updatedErrors.pan_number = value.trim() === '' ? 'field_required' : '';
               }
               
               
               
               return {
                    ...prevFormData,
                    formErrors: updatedErrors,
               };
          });

          return formData.formErrors;

     }

     function handleSubmit(e) {
          e.preventDefault();
          let post = {};
          let hasErrors = false;
          const updatedFormFields = formData.formFields.map((field) => {
               const allError = validateField(field.name, field.value);
               const error = allError[field.name];
               if (error !== '' && typeof error !== undefined) {
                    hasErrors = true;
               } else {
                    post[field.name] = field.value;
               }
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          if (!hasErrors && directSubmit == 0) {
               post['customer_id'] = id;
               subtmitData(post);
          } else {
               if (action === 'UPDATE') {
                    Alert.warning(t('you_did_not_change_anything'));
               } else {
                    Alert.warning(t('mandetory_fields'));
               }
          }
     }

     const subtmitData = async (post) => {        
          post['state'] = post['state'] === '' ? null : post['state'];
          const res = await httpClient.post(UPDATE_BILLING_DETAILS, post);
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    Alert.success(result.message);
                    navigate('/root/' + customerType);
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     function handleReset() {
          const updatedFormFields = formData.formFields.map((field) => ({
               ...field,
               value: '',
          }));

          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
               formErrors: {},
          }));
     }
     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader
                         title="billing_details"
                         subTitle={customerType}
                         subTitleLink={`root/${customerType}`}
                    />
                    <ul className="nav nav-tabs ml-3 mb-2">
                         <li className="nav-item">
                              <Link className="nav-link" to={`/root/${customerType}/edit/${id}`}>{t('basic')}</Link>
                         </li>
                         <li className="nav-item">
                              <Link className="nav-link active" to={`/root/${customerType}/taxDetails/${id}`}>{t('billing_details')}</Link>
                         </li>
                    </ul>
                    <div className='col-md-12 m-auto'>
                         <FormLayout
                              formTitle={formData.formTitle}
                              formFields={formData.formFields}
                              formErrors={formData.formErrors}
                              onFieldChange={handleFieldChange}
                              onFieldBlur={handleFieldBlur}
                              onSubmit={handleSubmit}
                              handleReset={handleReset}
                         />
                    </div>
               </div>
          </AdminLayout>
     )
}
